// Import model
import { WasteFactorCondition } from '../models/WasteFactorCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { WasteFactorIndexedFields } from '../models/WasteFactorIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { WasteFactorIndexedFieldsSerializer } from './WasteFactorIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for WasteFactorCondition - handles JSON serialization and deserialization with type validation
 */
export class WasteFactorConditionSerializer {
  /**
   * Deserializes a JSON string into a WasteFactorCondition instance
   */
  static deserialize(json: string): WasteFactorCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a WasteFactorCondition instance
   */
  static fromObject(obj: any): WasteFactorCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to WasteFactorCondition');
    }


    const instance: WasteFactorCondition = {
      fieldName: obj['fieldName'] as WasteFactorIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of WasteFactorCondition instances
   */
  static deserializeArray(json: string): WasteFactorCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a WasteFactorCondition instance to a JSON string
   */
  static serialize(instance: WasteFactorCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a WasteFactorCondition instance to a plain object
   */
  static toObject(instance: WasteFactorCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of WasteFactorCondition instances to a JSON string
   */
  static serializeArray(instances: WasteFactorCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
